module.exports = __webpack_public_path__ + "media/home2-right.5bf35c11.mp4";